
export function SocialIcon({ kind }: { kind: string }) {
  const common = { 
    width: 18, 
    height: 18, 
    viewBox: '0 0 24 24', 
    fill: 'none', 
    stroke: 'currentColor', 
    strokeWidth: 1.8, 
    strokeLinecap: 'round' as const, 
    strokeLinejoin: 'round' as const, 
    'aria-hidden': true 
  };
  
  const lowerKind = kind.toLowerCase();

  if (lowerKind === 'email' || lowerKind === 'mailto') return (
    <svg {...common}><rect x="3" y="5" width="18" height="14" rx="2"/><path d="M3 7l9 6 9-6"/></svg>
  );
  if (lowerKind === 'linkedin') return (
    <svg {...common}><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M8 10v7M8 7v.01M12 17v-4a2 2 0 0 1 4 0v4M12 12v5"/></svg>
  );
  if (lowerKind === 'github') return (
    <svg {...common}><path d="M9 19c-4 1.5-4-2-6-2m12 4v-3.5c0-1 .1-1.4-.5-2 2.8-.3 5.5-1.4 5.5-6a4.6 4.6 0 0 0-1.3-3.2 4.2 4.2 0 0 0-.1-3.2s-1.1-.3-3.5 1.3a12 12 0 0 0-6.2 0C6.5 2.8 5.4 3.1 5.4 3.1a4.2 4.2 0 0 0-.1 3.2A4.6 4.6 0 0 0 4 9.5c0 4.6 2.7 5.7 5.5 6-.6.6-.6 1.2-.5 2V21"/></svg>
  );
  if (lowerKind === 'twitter' || lowerKind === 'x') return (
    <svg {...common}><path d="M22 5.8a8 8 0 0 1-2.4.7 4 4 0 0 0 1.8-2.2 8 8 0 0 1-2.6 1 4 4 0 0 0-6.8 3.7 11.4 11.4 0 0 1-8.3-4.2 4 4 0 0 0 1.2 5.4 4 4 0 0 1-1.8-.5v.1a4 4 0 0 0 3.2 4 4 4 0 0 1-1.8.1 4 4 0 0 0 3.8 2.8A8 8 0 0 1 2 18a11.3 11.3 0 0 0 6.1 1.8c7.3 0 11.3-6 11.3-11.3v-.5A8 8 0 0 0 22 5.8z"/></svg>
  );
  if (lowerKind === 'medium') return (
    <svg {...common} fill="currentColor" stroke="none"><path d="M13.54 12a6.8 6.8 0 11-13.6 0 6.8 6.8 0 0113.6 0zM19 12c0 3.53-1.3 6.39-2.9 6.39s-2.9-2.86-2.9-6.39 1.3-6.39 2.9-6.39 2.9 2.86 2.9 6.39zM24 12c0 3.17-.31 5.75-.7 5.75s-.7-2.58-.7-5.75.31-5.75.7-5.75.7 2.58.7 5.75z"/></svg>
  );
  
  // Default fallback link icon
  return (
    <svg {...common}><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" /><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" /></svg>
  );
}
